import React, { Fragment, useState } from 'react';
import { PrivateMeetingSessionDetailsResponseType } from '../../../../lib/api';
import { classNameSessionHeaderRight, classNameSessionTableHeaderLeft, count, ICarouselBox, inc, renderSeparateLine, Styles } from './CarouselWrapper';
import { CardComponent } from './Card';
import Button from '../../../../components/button';
import CarouselByGrid from './CarouselByGrid';
import { getExpandButtonText } from '../helpers';
import { ITEMS_IN_SINGLE_ROW } from '../../../../lib/constants';
import DefaultCarousel from './DefaultCarousel';

export interface ICarouselWrapperItem extends Omit<ICarouselBox, 'meetings'> {
  featured: PrivateMeetingSessionDetailsResponseType[];
  noFeatured: PrivateMeetingSessionDetailsResponseType[];
  isTrack: boolean;
  sessions: number;
  track: string;
  classNameEventDetailsDate: string;
  isMobile: boolean | void;
}

const CarouselWrapperItem = ({
  featured,
  noFeatured,
  isTrack,
  sessions,
  track,
  classNameEventDetailsDate,
  event,
  eventToken,
  transformedTimeZone,
  shouldRenderSeparateLine,
  onSubscriptionChange,
  isMobile,
}: ICarouselWrapperItem): JSX.Element => {
  const [isCarouselView, setIsCarouselView] = useState(true);
  const expandButtonText = getExpandButtonText(isCarouselView);
  const shouldRenderExpandButton = noFeatured.length > ITEMS_IN_SINGLE_ROW;

  const switchCalouselView = () => {
    setIsCarouselView(prev => !prev);
  };

  return <Fragment>
    { isTrack &&
      <div role='columnheader' className={`${classNameSessionTableHeaderLeft} pb-8 px-5 flex flex-wrap`} >
        <div className='flex items-baseline'>
          <p className={`${classNameEventDetailsDate} font-size-16px ${Styles.headerCssClass} mb-2 flex justify-start md:justify-end mr-3`}>
            {track}
          </p>
          <span
            className={classNameSessionHeaderRight + 'flex mr-auto whitespace-no-wrap session-header'}
          >
            {`${sessions} ${sessions === count ? 'session' : 'sessions'}`}
          </span>
        </div>
        { shouldRenderExpandButton &&
          <div className='flex-grow ml-2'>
            <Button.Common
              name='show-all'
              className='button-expand flex mx-auto sm:mr-0 sm:ml-auto'
              onClick={switchCalouselView}
              title={track}
            >
              {expandButtonText} <span className='button-expand-text'>{ track }</span>
            </Button.Common>
          </div>
        }
      </div>
    }
    {!!featured.length &&
      <div className={Styles.blockCol}>
        {featured.map((meeting, i) => (
          <CardComponent
            meeting={meeting}
            index={i + inc}
            event={event}
            key={meeting.meetingId}
            eventToken={eventToken}
            transformedTimeZone={transformedTimeZone}
            isMobile={isMobile}
            onSubscriptionChange={onSubscriptionChange}
          />
        ))}
      </div>
    }
    {!!noFeatured.length && isCarouselView &&
      <DefaultCarousel
        meetings={noFeatured}
        event={event}
        eventToken={eventToken}
        transformedTimeZone={transformedTimeZone}
        shouldRenderSeparateLine={shouldRenderSeparateLine}
      />
    }
    {!!noFeatured.length && !isCarouselView &&
      <CarouselByGrid
        event={event}
        meetings={noFeatured}
        transformedTimeZone={transformedTimeZone}
        eventToken={eventToken}
      />
    }
    { shouldRenderExpandButton &&
      <div className='flex w-full justify-center mt-5 m-bottom-30px'>
        <Button.Common
          name='show-all'
          className='button-expand flex'
          onClick={switchCalouselView}
        >
          {expandButtonText} <span className='button-expand-text'>{ track }</span>
        </Button.Common>
      </div>
    }
    {renderSeparateLine(Boolean(noFeatured.length || featured.length))}
  </Fragment>;
};

export default CarouselWrapperItem;
